import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import {
    ProdutoTabKey,
    ProdutoTabKeyHistoricoAlteracao,
} from '@/features/produto/page/edit/body/useProdutoTabItems';
import { ProdutoEdit } from '@/features/produto/page/edit/ProdutoEdit';
import { StringToIdpkSchema } from '@/std/schema';

const RouteProdutoParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'clonar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteProdutoParams = z.infer<typeof RouteProdutoParamsSchema>;

const schema = z.union([
    z.object({
        tab1: z.literal(ProdutoTabKey.HistoricoAlteracoes),
        tab2: z.enum(ProdutoTabKeyHistoricoAlteracao),
    }),
    z.object({
        tab1: z.enum(ProdutoTabKey).default(ProdutoTabKey.Geral),
    }),
]);

// biome-ignore assist/source/useSortedKeys: type inference
export const Route = createFileRoute('/a/produto/$action/{-$idpk}')({
    validateSearch: schema,
    params: {
        parse: (params) => {
            const result = RouteProdutoParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    component: Component,
});

function Component() {
    const params = Route.useParams();

    return <ProdutoEdit {...params} />;
}
